import type { TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export function Textarea({ error = false, className = '', ...props }: TextareaProps) {
  return (
    <textarea
      className={`input resize-none ${error ? 'input-error' : ''} ${className}`}
      {...props}
    />
  );
}
